<!-- eslint-disable max-len -->
<div class="input input-select" [class]="{'error': error, 'disabled': disabled, 'full-width': fullWidth}">
  @if (label) {
    <label [attr.for]="id">{{label}}@if (required) {
      <span class="required-star"> *</span>
    }</label>
  }
  <div class="select-wrap">
    <select
      [disabled]="disabled"
      [attr.id]="id"
      [attr.name]="name"
      type="text"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      [required]="required"
      [attr.placeholder]="placeholder"
      (input)="inputEvent.emit($event)"
      (blur)="onBlur($event)"
      (focus)="focusEvent.emit($event)"
      (keydown)="keyDownEvent.emit($event)"
      (keyup)="keyUpEvent.emit($event)">
      @for (option of options; track option) {
        <option [value]="getOptionValue(option)">{{getOptionText(option)}}</option>
      }
    </select>
    <div class="chevron">
      <svg width="17" height="24" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.15742 13.3139L11.4423 8.36388C11.5035 8.26837 11.5767 8.19219 11.6577 8.13978C11.7386 8.08737 11.8257 8.05979 11.9138 8.05863C12.0019 8.05748 12.0893 8.08278 12.1709 8.13306C12.2524 8.18334 12.3265 8.25759 12.3888 8.35149C12.4511 8.44538 12.5004 8.55703 12.5338 8.67993C12.5671 8.80282 12.5839 8.9345 12.5832 9.06728C12.5824 9.20006 12.5641 9.33128 12.5293 9.45329C12.4945 9.57529 12.444 9.68564 12.3806 9.77788L8.62659 15.4349C8.50214 15.6224 8.33338 15.7277 8.15742 15.7277C7.98145 15.7277 7.81269 15.6224 7.68825 15.4349L3.93425 9.77788C3.87087 9.68564 3.82031 9.57529 3.78553 9.45329C3.75076 9.33128 3.73245 9.20006 3.73168 9.06728C3.73092 8.9345 3.74771 8.80282 3.78108 8.67993C3.81444 8.55703 3.86372 8.44538 3.92602 8.35149C3.98833 8.25759 4.06242 8.18334 4.14398 8.13306C4.22553 8.08278 4.31292 8.05748 4.40103 8.05863C4.48914 8.05979 4.57622 8.08737 4.65718 8.13978C4.73814 8.19219 4.81137 8.26837 4.87258 8.36388L8.15742 13.3139Z"
          fill="black" />
      </svg>
    </div>
  </div>
  @if (showMessages) {
    <div class="messages">
      @for (error of errorMessages; track error) {
        <small class="error">{{error}}</small>
      }
      <ng-content></ng-content>
    </div>
  }
</div>
